import { generateUtilityClasses } from "@mui/material";
const toolbarModalDrawerName = "TidalToolbarModalDrawer";
const toolbarModalDrawerClasses = generateUtilityClasses(
  toolbarModalDrawerName,
  ["closed", "open", "root"]
);
export {
  toolbarModalDrawerClasses,
  toolbarModalDrawerName
};
//# sourceMappingURL=classes.js.map
